export const fondosPension = [
  { value: 'COLFONDOS', label: 'COLFONDOS' },
  { value: 'SKANDIA', label: 'SKANDIA' },
  { value: 'PORVENIR', label: 'PORVENIR' },
  { value: 'PROTECCIÓN', label: 'PROTECCIÓN' },
];
